/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/charger'
export default icon
